<template>
  <v-container fluid class="purchaseorder-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Purchase Order</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
              <v-divider v-if="isTrade"></v-divider>
              <v-stepper-step v-if="isTrade" :complete="step > 3" step="3">Trade Terms</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Purchase Order</p>
                        <v-select
                          class="mb-4"
                          :items=purchaseordertype
                          v-model="purchaseorder.purchaseordertype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the purchase order type">
                        </v-select>
                        <v-menu
                          ref="menu_purchaseorderdate"
                          v-model="menu_purchaseorderdate"
                          :close-on-content-click="false"
                          :return-value.sync="purchaseorder.purchaseorderdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="purchaseorder.purchaseorderdate"
                              label="Purchase Order Date"
                              v-bind="attrs"
                              v-bind:value="purchaseorder.purchaseorderdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the purchase order type">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="purchaseorder.purchaseorderdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_purchaseorderdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_purchaseorderdate.save(purchaseorder.purchaseorderdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-switch
                          v-model="purchaseorder.purchaseorderstatus"
                          color="primary"
                          v-bind:label="purchaseorder.purchaseorderstatus"
                          value="New"
                        ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="vendors.filter(vendor=>vendor.vendortype=='Supplier').map(x => {
                            return {text: x.vendorname, value: x._id};
                            })"
                          v-model="purchaseorder.vendorid"
                          v-bind:error="errorindex == 2"
                          v-on:change="populateVendorFields"
                          outlined
                          dense
                          placeholder="Vendor"
                          persistent-hint
                          single-line hint="Please choose the vendor">
                        </v-select>                        
                        <v-text-field
                          class="mb-4"
                          v-model="purchaseorder.purchaseordername"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="Vendor Name"
                          persistent-hint
                          single-line hint="Enter the Vendor Name">
                        </v-text-field>
                        <v-textarea
                          v-model="purchaseorder.purchaseorderaddress"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the vendor address"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="regions.map(x => {
                            return {text: x.regionname, value: x._id};
                            })"
                          v-model="purchaseorder.regionid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="purchaseorder.purchaseorderphone"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="purchaseorder.purchaseordermobile"
                          v-bind:error="errorindex == 12"
                          outlined
                          dense
                          placeholder="Mobile"
                          persistent-hint
                          single-line hint="Enter the mobile phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="pricelists.map(x => {
                            return {text: x.pricelistname, value: x._id};
                            })"
                          v-model="purchaseorder.pricelistid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Price List"
                          persistent-hint
                          single-line hint="Please choose the pricelist">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=purchaseorderpayterms
                          v-model="purchaseorder.purchaseorderpayterms"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Pay Terms"
                          persistent-hint
                          single-line hint="Please choose the pay terms">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="purchaseorder.purchaseordernote"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/purchaseorder/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <p class="text-h5">Items</p>
                      <v-form>
                        <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="brands.map(x => {
                              return {text: x.brandname, value: x._id};
                              })"
                            v-model="brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line hint="Brand">
                          </v-select>
                        </v-col>
                        <v-col md="4">
                        <v-select
                          class="mb-4"
                          :items=branditems
                          v-model="itemid"
                          v-bind:error="errorindex == 0"
                          v-on:change="populatePriceField"
                          outlined
                          dense
                          placeholder="Item"
                          persistent-hint
                          single-line hint="Item">
                        </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 1) this.value = 1;"
                            single-line hint="Quantity">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="itemprice"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line hint="Price">
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            readonly
                            v-model="itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line hint="Amount">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="success"
                            @click="addTransaction()">
                            Add
                          </v-btn>
                        </v-col>
                        </v-row>
                          <v-data-table
                            :headers="headers"
                            :items="transactions"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.itemimage="{ item }"> 
                              <v-img
                                v-bind:lazy-src="item.itemimage"
                                min-width=50
                                max-width=100
                                v-bind:src="item.itemimage"
                              ></v-img>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="loadTransaction(item)">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn icon color="primary" @click="deleteTransaction(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <template slot="body.append">
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th>Subtotal</th>
                                  <th>{{ purchaseorder.purchaseordersubtotal }}</th>
                                  <th></th>
                              </tr>
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th>Total</th>
                                  <th>{{ purchaseorder.purchaseordersubtotal }}</th>
                                  <th></th>
                              </tr>
                            </template>
                          </v-data-table>
                      </v-form>
                    </v-col>
                  </v-row>
                    <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="isTrade"
                            class="button-shadow"
                            color="primary"
                            @click="step = 3">
                            Next
                          </v-btn>
                          <v-btn
                            v-else
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertPurchaseOrder()">
                            Save
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">Trade Terms</p>
                        <v-text-field
                          class="mb-4"
                          v-model="trade.refnum"
                          outlined
                          dense
                          placeholder="Reference Number"
                          persistent-hint
                          single-line hint="Enter the reference number">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=incoterms
                          v-model="trade.incoterms"
                          outlined
                          dense
                          placeholder="Incoterms"
                          persistent-hint
                          single-line hint="Please choose incoterms">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_etddate"
                          v-model="menu_etddate"
                          :close-on-content-click="false"
                          :return-value.sync="trade.etddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="trade.etddate"
                              label="ETD Date"
                              v-bind="attrs"
                              v-bind:value="trade.etddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter ETD date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="trade.etddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_etddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_etddate.save(trade.etddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_etadate"
                          v-model="menu_etadate"
                          :close-on-content-click="false"
                          :return-value.sync="trade.etadate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="trade.etadate"
                              label="ETA Date"
                              v-bind="attrs"
                              v-bind:value="trade.etadate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter ETA date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="trade.etadate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_etadate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_etadate.save(trade.etadate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>                       
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="trade.portloading"
                          outlined
                          dense
                          placeholder="Port of Loading"
                          persistent-hint
                          single-line hint="Enter the loading port">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="trade.portdischarge"
                          outlined
                          dense
                          placeholder="Port of Discharge"
                          persistent-hint
                          single-line hint="Enter the discharge port">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 2"
                          >
                            Back
                          </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            v-if="isTrade"
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertPurchaseOrder()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
     <div class="text-center">
        <v-bottom-sheet
          v-model="sheet"
          inset
        >
          <v-sheet
            class="text-center"
            height="220px"
          >
            <v-btn
              class="mt-6"
              text
              color="error"
              @click="sheet = !sheet"
            >
              close
            </v-btn>
                    <div class="my-3">
                      <v-row justify="center">
                        <v-col md="2">
                          <v-select
                            class="mb-4"
                            :items="brands.map(x => {
                              return {text: x.brandname, value: x._id};
                              })"
                            v-model="brandid"
                            v-bind:error="errorindex == 2"
                            v-on:change="populateItems"
                            outlined
                            dense
                            placeholder="Brand"
                            persistent-hint
                            single-line hint="Brand">
                          </v-select>
                        </v-col>
                        <v-col md="4">
                        <v-select
                          class="mb-4"
                          :items=branditems
                          v-model="itemid"
                          v-bind:error="errorindex == 0"
                          v-on:change="populatePriceField"
                          outlined
                          dense
                          placeholder="Item"
                          persistent-hint
                          single-line hint="Item">
                        </v-select>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            v-model="itemquantity"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Qty"
                            persistent-hint
                            type="number"
                            v-on:input="calculateAmount"
                            oninput="if(this.value < 1) this.value = 1;"
                            single-line hint="Qty">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">
                          <v-text-field
                            readonly
                            v-model="itemprice"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Prc"
                            persistent-hint
                            single-line hint="Price">
                          </v-text-field>
                        </v-col>
                        <v-col md="2">
                          <v-text-field
                            readonly
                            v-model="itemamount"
                            class="mb-4"
                            outlined
                            dense
                            placeholder="Amt"
                            persistent-hint
                            single-line hint="Amount">
                          </v-text-field>
                        </v-col>
                        <v-col md="1">

                        </v-col>
                        </v-row>
                      </div>
                          <v-btn
                            class="button-shadow"
                            color="warning"
                            @click="editTransaction()">
                            Edit
                          </v-btn>
          </v-sheet>
        </v-bottom-sheet>
  </div>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      headers: [
        { text: 'Image', value: 'itemimage' },
        { text: 'Name', value: 'itemname' },
        { text: 'Foc', value: 'itemfoc' },
        { text: 'Qty', value: 'itemquantity' },
        { text: 'Prc', value: 'itemprice' },
        { text: 'Amount', value: 'itemamount' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      transactions: [],
      sheet: false,
      brandid: undefined,
      price: undefined,
      cid: undefined,
      itemimage: undefined,
      itemid: undefined,
      itemname: undefined,
      itemquantity: 1,
      itemfoc: undefined,
      itemprice: undefined,
      itemamount: undefined,
      itemcategoryid: undefined,
      itemsubcategoryid: undefined,
      step: 1,
      purchaseorder: {
        purchaseorderstatus: 'New',
        purchaseordersubtotal: 0,
        purchaseorderdeliverycost: 0,
        purchaseordertotal: 0,
      },
      trade: {},
      isTrade: false,
      menu_purchaseorderdate: false,
      menu_etddate: false,
      menu_etadate: false,
      purchaseordertype: ['Purchase Order', 'Cash Order', 'Pre Order'],
      purchaseorderpayterms: ['Cash', 'Credit 15 Days', 'Credit 30 Days'],
      incoterms: ['FOB', 'CIF', 'Ex-works'],
      branditems: [],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Price', ['getPricesRequest']),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('PurchaseOrder', ['getPurchaseOrders', 'insertPurchaseOrderRequest']),
    checkError(){
      if(!this.purchaseorder.purchaseordertype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.purchaseorder.purchaseorderdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.purchaseorder.vendorid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.purchaseorder.regionid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.purchaseorder.pricelistid){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      if(!this.purchaseorder.purchaseorderpayterms){
        this.haserrors = true;
        this.errorindex = 5;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    populateVendorFields(vendorid){
      console.log(vendorid)
      var vendor = this.vendors.find(vendor=>vendor._id == vendorid);
      this.purchaseorder.purchaseordername = vendor.vendorname;
      this.purchaseorder.purchaseorderaddress = vendor.vendoraddress;
      this.purchaseorder.purchaseorderphone = vendor.vendorphone;
      this.purchaseorder.purchaseordermobile = vendor.vendormobile;
      this.purchaseorder.regionid = vendor.regionid;
      this.purchaseorder.pricelistid = vendor.pricelistid;
    },
    populateItems(brandid){
      let items = this.items.filter(item=>item.brandid == brandid);
      this.branditems = items.map(x => {return {text: x.itemname, value: x._id};})
    },
    populatePriceField(itemid){
      let price = this.prices.find(price=>price.itemid == itemid && price.pricelistid==this.purchaseorder.pricelistid);
      let item = this.items.find(item=>item._id == itemid);
      console.log(item);
      this.price = price;
      this.itemprice = price.listprice;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
      this.calculateAmount();
    },
    calculateAmount(){
      this.itemamount = this.itemquantity * this.itemprice;
    },
    calculateTotal(){
      this.purchaseorder.purchaseordersubtotal = this.transactions.reduce((a, b) => a + (b['itemamount'] || 0), 0);
      this.purchaseorder.purchaseordertotal = this.purchaseorder.purchaseordersubtotal;
    },
    addTransaction(){
      if(this.itemprice==null || this.itemamount==null){return}
      let index = this.findTransactionIndexByItemid(this.itemid);
      if(index==-1){this.insertTransaction()}
      else{this.updateTransaction(index)}
      this.calculateTotal();
      this.clearTransaction();
    },
    insertTransaction(){
      this.transactions.push({
        id: Math.floor(Math.random() * Math.pow(10, 10)),
        regionid: this.purchaseorder.regionid,
        vendorid: this.purchaseorder.vendorid,
        brandid: this.brandid,
        itemid: this.itemid,
        itemimage: this.itemimage,
        itemname: this.itemname,
        itemquantity: this.itemquantity,
        itemfoc: '',
        itemprice: this.itemprice,
        itemamount: this.itemamount,
        itemcategoryid: this.itemcategoryid,
        itemsubcategoryid: this.itemsubcategoryid,
      });
      this.insertFOCTransaction();
    },
    insertFOCTransaction(){
      if(this.price.foc.enable==true){
        let totalqty = this.getItemQuantityBySubcategory(this.itemsubcategoryid);
        console.log(totalqty);
        if(totalqty>=this.price.foc.itemqty){
          this.transactions.push({
            id: Math.floor(Math.random() * Math.pow(10, 10)),
            brandid: this.brandid,
            regionid: this.purchaseorder.regionid,
            vendorid: this.purchaseorder.vendorid,
            itemcategoryid: this.itemcategoryid,
            itemsubcategoryid: this.itemsubcategoryid,
            itemid: this.itemid,
            itemimage: this.itemimage,
            itemname: this.itemname,
            itemquantity: parseInt((totalqty / this.price.foc.itemqty) * this.price.foc.getitemqty),
            itemfoc: 'foc',
            itemprice: 0,
            itemamount: 0,
          });
        }
      }
    }, 
    updateTransaction(index){
      var tran = this.transactions[index];
      tran.itemquantity =  parseInt(tran.itemquantity) + parseInt(this.itemquantity);
      tran.itemamount = tran.itemquantity * tran.itemprice;
      this.updateFOCTransaction();
    },
    updateFOCTransaction(){

      if(this.price.foc.enable==true){
        if(this.itemquantity>=this.price.foc.itemqty){
          this.transactions.push({
            id: Math.floor(Math.random() * Math.pow(10, 10)),
            brandid: this.brandid,
            regionid: this.purchaseorder.regionid,
            vendorid: this.purchaseorder.vendorid,
            itemcategoryid: this.itemcategoryid,
            itemsubcategoryid: this.itemsubcategoryid,
            itemid: this.itemid,
            itemimage: this.itemimage,
            itemname: this.itemname,
            itemquantity: this.price.foc.getitemqty,
            itemprice: 0,
            itemamount: 0,
          });
        }
      }
    },
    deleteTransaction(item){
      let index = this.findTransactionIndexById(item.id);
      this.transactions.splice(index,1);
      this.calculateTotal();
    },
    clearTransaction(){
      this.cid = undefined;
      this.itemid = undefined;
      this.itemimage = undefined;
      this.itemname = undefined;
      this.itemquantity = 1;
      this.itemprice = undefined;    
      this.itemamount = undefined;
      this.itemcategoryid = undefined
      this.itemsubcategoryid = undefined;
    },
    loadTransaction(item){
      this.cid = item.id;
      this.sheet = !this.sheet;
      this.brandid = item.brandid;
      this.itemid = item.itemid;
      this.itemimage = item.itemimage;
      this.itemname = item.itemname;
      this.itemquantity = item.itemquantity;
      if(this.itemfoc=='foc'){
        this.itemprice = 0
      }
      else {
        this.itemprice = item.itemprice;
      }
    
      this.itemamount = item.itemamount;
      this.itemcategoryid = item.itemcategoryid;
      this.itemsubcategoryid = item.itemsubcategoryid;
    },
    editTransaction(){
      var trans = this.transactions.find(tran=>tran.id==this.cid);
      trans.brandid = this.brandid;
      trans.itemid = this.itemid;
      trans.itemimage = this.itemimage;
      trans.itemname = this.itemname;
      trans.itemquantity = this.itemquantity;
      if(trans.itemfoc=='foc'){
        trans.itemprice = 0
      }
      else {
        trans.itemprice = this.itemprice;
      }
    
      trans.itemamount = this.itemamount;
      trans.itemcategoryid = this.itemcategoryid;
      trans.itemsubcategoryid = this.itemsubcategoryid;
      this.sheet = !this.sheet;
      this.calculateTotal();
      this.clearTransaction();
    },
    findTransactionIndexById(id){
      let index;
      if(this.transactions.find(tran=>tran.id==id)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].id==id){break;}
      }
      return index;
    },
    findTransactionIndexByItemid(itemid){
      let index;
      if(this.transactions.find(tran=>tran.itemid==itemid)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].itemid==itemid){break;}
      }
      return index;
    },
    getItemQuantityBySubcategory(subcategoryid){
      let filter_trans = this.transactions.filter(tran=>tran.itemsubcategoryid==subcategoryid);
      var sum = filter_trans.reduce((partial_sum, tran) => parseInt(partial_sum) + parseInt(tran.itemquantity),0);
      return sum;
    },
    async insertPurchaseOrder() {
      this.purchaseorder.trade = this.isTrade ? this.trade : null;
      let order = {purchaseorder: this.purchaseorder,transactions: this.transactions};
      await this.insertPurchaseOrderRequest(order);
      router.push('/purchaseorder/list');
    },
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Vendor', ['vendors']),
    ...mapState('Item', ['items']),
    ...mapState('Price', ['prices']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Region', ['regions']),
    ...mapState('PurchaseOrder', ['isReceiving'])
  },
  created () {
    if(this.brands.length==0){this.getBrandsRequest()}
    if(this.vendors.length==0){this.getVendorsRequest()}
    if(this.items.length==0){this.getItemsRequest()}
    if(this.prices.length==0){this.getPricesRequest()}
    if(this.pricelists.length==0){this.getPriceListsRequest()}
    if(this.regions.length==0){this.getRegionsRequest()}
    if(this.regions.length==0){this.getRegionsRequest()}
    var companyid = localStorage.getItem('companyid');
    if(companyid=='60a8acb67418a3429476cd42'){
      this.isTrade = true;
      this.purchaseorderpayterms = ['100% TT', 'Credit 15 Days', 'Credit 30 Days']
    }
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
